import RtwInventoryTypes from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: RtwInventoryTypes.GET_RTW_INVENTORY_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: RtwInventoryTypes.GET_RTW_INVENTORY_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: RtwInventoryTypes.GET_DETAIL_RTW_INVENTORY_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: RtwInventoryTypes.GET_DETAIL_RTW_INVENTORY_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: RtwInventoryTypes.PUT_RTW_INVENTORY,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: RtwInventoryTypes.PUT_RTW_INVENTORY_SUCCESS,
  payload: data,
})


const RtwInventoryAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,

  putData,
  putDataSuccess,
}

export default RtwInventoryAction





